import { takeLatest, call, put, select } from 'redux-saga/effects'

import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import { IMainState } from 'store/states'
import DestroyMany from 'api/administration/monitoring/DestroyMany'
import * as fromActions from '../../actions/monitoring.actions'

const pattern = fromActions.USER_MONITORING_DESTROY_MANY

function* destroyEffectSaga(
  action: ActionWithPayload<typeof pattern, fromActions.DestroyPayload>
) {
  try {
    const { q, search, sendReport } = action.payload
    const { course } = yield select(({ courses }: IMainState) => courses)
    yield call(DestroyMany, course.id, {
      q,
      search,
      sendReport,
    })
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* destroyManyWatcherSaga() {
  yield takeLatest(pattern, destroyEffectSaga)
}
